import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=eaeba33e&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"
import style0 from "./logistics.vue?vue&type=style&index=0&id=eaeba33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaeba33e",
  null
  
)

export default component.exports